"use strict";

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;
  // wrap inside a timeout to ensure the title has properly been changed
  setTimeout(function () {
    window.dataLayer.push({
      event: "gatsby-route-change"
    });
  }, 50);
};